export const whyCards = [
    {
        title: '🔥 UNIQUE SETTING',
        text: 'Cat-Cyberpunk 18+ with a bold tone. Not for snowflakes.',
    },
    {
        title: '💥 HOT WEB3 TOPIC',
        text: 'Real NFT ownership—zero startup hassle. The perfect case study.',
    },
    {
        title: '🎮 CONTENT DEPTH',
        text: 'Economy, factions, endless progression—hundreds of gameplay hours.',
    },
    {
        title: '👨‍🎤 MATURE AUDIENCE',
        text: 'Players craving dark themes, tired of "sterile games".',
    },
    {
        title: '🚀 EARLY ACCESS/HYPE',
        text: 'Be the first to expose this world!',
    },
];

export const perkCards = [
    {
        title: '🎮 EARLY ACCESS /\n' + ' BETA KEYS',
        text: 'Play before launch!',
    },
    {
        title: '💎 EXCLUSIVE CONTENT',
        text: 'Art "for your eyes only", dev interviews, roadmap.',
    },
    {
        title: '🎁 AUDIENCE REWARDS',
        text: 'Unique in-game items (weapons, equipments, awards). "Thank your viewers for trusting you!"',
    },
    {
        title: '🤝 1-ON-1 SUPPORT',
        text: 'PR manager on Discord/Email for Q&A, interviews, collabs.',
    },
    {
        title: '📢 PROMOTE YOUR\n' + 'CONTENT',
        text: 'We’ll feature your best review/stream on our socials & Discord!',
    },
];

export const tables = [
    {
        id: 1,
        content: [
            {
                title: 'Official Title',
                text: 'Neuroborn Cats',
            },
            {
                title: 'Tagline',
                text: 'Hunt. Betray. Rule.',
            },
            {
                title: 'Developer',
                text: 'Gatia Labs is an indie collective of tech renegades. By day we maintain corporate systems — by night we build the game the industry is too scared to make',
            },
        ]
    },
    {
        id: 2,
        content: [
            {
                title: 'Platform',
                text: 'Browser (any modern)',
            },
            {
                title: 'Genre',
                text: 'MMO-RPG (Cyberpunk Sandbox)',
            },
            {
                title: 'Age Rating',
                text: '18+ (Brutal violence, explicit content, pervasive profanity, dark humor)',
            },
            {
                title: 'Business Model',
                text: 'Free-to-Play (F2P)',
            }
        ]
    },
    {
        id: 3,
        content: [
            {
                title: 'Web3 Integration',
                text: 'Yes (WAX blockchain, NFT assets, real ownership)',
            },
            {
                title: 'Status',
                text: 'Pre-Alpha | Registration Open',
            },
            {
                title: 'Play Now',
                link: 'https://game.neuroborncats.com/',
            },
            {
                title: 'Discord',
                link: 'https://discord.gg/MgV32NTpAH',
            },
        ]
    }
];

export const featuresCards = [
    {
        title: 'A UNIQUE 18+ SETTING',
        text: 'Neuro-cats in a fucked-up cyberpunk world. A brutal, cynical world without sugarcoating or political correctness.',
        italic: '"Swearing is small talk, violence is an argument, and sex is bargaining chips."',
    },
    {
        title: 'ENDLESS PROGRESSION & FREEDOM',
        text: 'Become a killing machine, a shadow mogul, an industrial titan – or all of the above. Dozens of levels and skills. There is no ceiling.',
    },
    {
        title: 'PLAYER-DRIVEN ECONOMY',
        text: 'Build empires from nothing: hire players, manage supply chains, monopolize markets, crush rivals. Own NFT businesses, land, rare assets – and sell them on real marketplaces.',
    },
    {
        title: 'FACTIONS & RUTHLESS SOCIETY',
        text: 'Rule alone or unite in gangs, guilds, and syndicates. Betray, scheme, and seize power in the eternal struggle for influence and elite tech.',
    },
    {
        title: 'WEB3 WITHOUT THE BULLSHIT',
        text: 'True ownership of key in-game assets (NFTs) that you can sell, trade, or gift. All you need is an email to start. Play for free, earn your first NFTs in-game.',
    }
]